import React from 'react';

import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import PageTemplate from './PageTemplate';

import { PAYMENT_METHOD_SET } from '../../../lib/PaymentInfo';
import * as PATH from '../../../lib/routes/path';
import {
  MYPAGE_ORDER_DETAIL_MENU,
  MYPAGE_ORDER_MENU,
} from '../../../lib/routes/MyPageRoutes';
import { ReactComponent as Logo } from '../../../lib/image/icons/logo/LOGO02.svg';

const CompletionTemplate = ({
  ultrasoundInfo,
  paymentInfo,
  linkToOrderDetail,
  LinkToPath,
}) => {
  const checkUltrasound = () => {
    if (ultrasoundInfo.length < 1) {
      alert(
        `초음파 사진 업로드중 오류가 발생하였습니다. "${MYPAGE_ORDER_MENU.label} > ${MYPAGE_ORDER_DETAIL_MENU.label}"에서 초음파 사진을 추가해주세요`,
      );
      return (
        <>
          <Flex>
            <Text size={14} style={{ lineHeight: '1.43' }} textAlign="center">
              초음파사진 업로드 중 오류가 발생하였습니다.
              <br />
              <b>
                {MYPAGE_ORDER_MENU.label} {'>'} {MYPAGE_ORDER_DETAIL_MENU.label}
              </b>
              에서 초음파 사진을 추가해주세요!
            </Text>
          </Flex>
          <Flex padding="1.875rem 0 0.75rem">
            <Button onClick={linkToOrderDetail}>
              <Text size={14}>추가하러 가기</Text>
            </Button>
          </Flex>
        </>
      );
    }
  };

  if (!paymentInfo) {
    return null;
  }
  return (
    <PageTemplate>
      <Flex padding="1.2rem 0 1.875rem">
        <Logo style={{ width: '8rem', height: '7.785rem' }} />
      </Flex>
      {ultrasoundInfo && checkUltrasound()}
      {!paymentInfo.items[0].shippingToAffiliate &&
        !paymentInfo.items[0].voucher &&
        paymentInfo.items[0].shipmentRequired && (
          <Flex padding="0 0 1.875rem">
            <Text
              size={14}
              textAlign="center"
              style={{ lineHeight: 1.43, wordBreak: 'keep-all' }}
            >
              인화된 사진은 디지털 사진 제작이 완료된 후 익일 택배로 발송되며,
              배송은 평일 기준 2~3일 소요됩니다.
            </Text>
          </Flex>
        )}
      <Flex>
        <Text size={18} weight="medium">
          {paymentInfo.paymentMethod === 'VIRTUAL_ACCOUNT'
            ? '은행에 입금해주시면, 결제가 완료됩니다.'
            : '주문이 완료되었습니다.'}
        </Text>
      </Flex>
      <Flex column padding="1.875rem 0" alignItems="stretch">
        {VIRTUAL_ACCOUNT_INFO.slice(
          0,
          paymentInfo.paymentMethod === 'VIRTUAL_ACCOUNT' ? 7 : 3,
        ).map((info) => (
          <Flex justifyContent="space-between" key={info.label}>
            <Text size={14} lineHeight="2.14">
              {info.label}
            </Text>
            <Text size={14}>
              {info.label === '예금주'
                ? info.value
                : info.value === 'paymentMethod'
                ? PAYMENT_METHOD_SET[paymentInfo[info.value]]
                : info.value === 'finalPrice'
                ? `${paymentInfo[info.value].toLocaleString()}원`
                : paymentInfo[info.value]}
            </Text>
          </Flex>
        ))}
      </Flex>
      <Flex>
        <Text size={12}>
          주문 내용 및 결과는 {MYPAGE_ORDER_MENU.label}에서 확인하실 수
          있습니다.
        </Text>
      </Flex>
      <Flex padding="1.875rem 0 0.75rem">
        {COMPLETION_BUTTON_LIST.map((button) => (
          <Button
            key={button.label}
            color={button.color}
            onClick={() => LinkToPath(button.path)}
            style={{ width: '5.5rem', marginRight: button.marginRight }}
          >
            <Text size={14}>{button.label}</Text>
          </Button>
        ))}
      </Flex>
    </PageTemplate>
  );
};

export default CompletionTemplate;

const VIRTUAL_ACCOUNT_INFO = [
  { label: '결제일시', value: 'createDateTime' },
  { label: '결제정보', value: 'paymentMethod' },
  { label: '결제금액', value: 'finalPrice' },
  { label: '입금은행', value: 'vbankName' },
  { label: '입금계좌번호', value: 'vbankNum' },
  { label: '예금주', value: '알레시오 주식회사' },
  { label: '입금 마감 시한', value: 'vbankDeadline' },
];

const COMPLETION_BUTTON_LIST = [
  {
    path: PATH.HOME,
    marginRight: '2.5rem',
    label: '홈으로',
    color: 'brownGrey',
  },
  {
    path: PATH.MYPAGE_ORDER,
    marginRight: 0,
    label: '주문확인',
    color: 'orangePink',
  },
];
